import React, {useState,useEffect, useRef} from 'react';
import {fabric} from "fabric";


var rect = new fabric.Rect;
var SCALE_FACTOR = 1.3;
var zoomMax =2;


const Zoom = (props) => {
    const [value,setValue]=useState(0.9);
    const _canvasZ = useRef(0);

    useEffect(()=>{
        if (!_canvasZ.current) {
            _canvasZ.current =  new fabric.Canvas('zoom');
        }

        if (props.show) {
           // imageDraw();
            cropRect();
            //setBG();
            setBackgroundFromDataUrl(props.image);

            setValue(0.9);
        }

        _canvasZ.current.renderAll();
    });


    const setBackgroundFromDataUrl = (dataUrl) => {
        if (!dataUrl) { return true; }

        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {

            // maxWidth // Max width of the canvas
            // maxHeight //Max height of canvas
            let maxWidth=1000;
            let maxHeight=800;

            let imgWidth = img.width; // Current image width
            let imgHeight = img.height; // Current image height

            let widthAspectRatio = maxWidth / imgWidth;
            let heightAspectRatio = maxHeight / imgHeight;

            let finalAspectRatio = Math.min(widthAspectRatio, heightAspectRatio)

            let finalHeight = imgHeight * finalAspectRatio;
            let finalWidth = imgWidth * finalAspectRatio;

            let imgTop = 0;
            if (maxHeight > finalHeight) {
                imgTop = (Math.round(maxHeight) - Math.round(finalHeight)) / 2;
            }

            let imgLeft = 0;
            if (maxWidth > finalWidth) {
                imgLeft = (Math.round(maxWidth) - Math.round(finalWidth)) / 2;
            }

            let nsgImage = new fabric.Image(img).scale(finalAspectRatio);
            nsgImage.set({ left: imgLeft, top: imgTop });

            _canvasZ.current.setBackgroundImage(nsgImage, () => _canvasZ.current.renderAll());

        }

        img.src = dataUrl;

    };





    function setBG() {
        _canvasZ.current.setBackgroundImage(props.image,  _canvasZ.current.renderAll.bind( _canvasZ.current), {
            backgroundImageOpacity: 0.5,
            backgroundImageStretch: false,
            scaleX :0.2,   //new update
            scaleY:0.2,
        });

        // fabric.Image.fromURL(props.image, function (img) {
        //     //  this.setState({bgImage:bg});
        //
        //     _canvasZ.current.setBackgroundImage(img, _canvasZ.current.renderAll.bind(_canvasZ.current), {
        //         left:(_canvasZ.current.getWidth()/2)-(img.width/2),
        //         top:(_canvasZ.current.getHeight()/2)-(img.height/2),
        //         // "left":(canvas.width/2)-(img.width/2),
        //         // "top":(canvas.height/2)-(img.height/2),
        //         backgroundImageStretch: false,
        //         scaleX: 0.9,
        //         scaleY: 0.9,
        //
        //     });
        //     _canvasZ.current.centerObject(img);
        //     _canvasZ.current.renderAll()
        //
        // });
    }


    // Zoom In
    function setZoom(e) {
        setValue(e.target.value);
        // if(_canvasZ.current.getZoom().toFixed(5) > zoomMax){
        //     console.log("zoomIn: Error: cannot zoom-in anymore");
        //     return;
        // }

        var point = new fabric.Point(500, 400);
        _canvasZ.current.zoomToPoint(point, Math.pow(2,e.target.value));
        //keepPositionInBounds(_canvasZ.current);
        // _canvasZ.current.setZoom(e.target.value);
       // _canvasZ.current.setHeight(_canvasZ.current.getHeight() * value);
       // _canvasZ.current.setWidth(_canvasZ.current.getWidth() * value);
        _canvasZ.current.renderAll();
    }


    function cropRect() {
      rect.set({
            left: 300,
            top: 200,
            width: 400,
            height:props.size,
            strokeDashArray: [10, 10],
            stroke: 'green',
            strokeWidth:5,
            fill: 'rgba(0,0,0,0)',
            hasControls: false,
            hasBorders: false,

        });
         rect.lockScalingX = rect.lockScalingY= rect.lockScalingFlip =rect.lockRotation= rect.hiddenTextarea= true;
        _canvasZ.current.add(rect);
        console.log(rect);

    }


    function imageDraw  () {
        _canvasZ.current.clear();
        fabric.Image.fromURL(props.image, function (oImg) {
            oImg.set({
                selectable:true,
                width: oImg.width,
                height:oImg.height,
                originX: 'left',
                scaleX : _canvasZ.current.getWidth()/oImg.width,   //new update
                scaleY: _canvasZ.current.getHeight()/oImg.height,   //new update
                originY: 'top',
                left:(_canvasZ.current.width/2)-(oImg.width/2),
                top:(_canvasZ.current.height/2)-(oImg.height/2),
            })
            //_canvasZ.current.setDimensions({width:oImg.width, height:oImg.height})
            _canvasZ.current.add(oImg);
            _canvasZ.current.centerObject(oImg);
            _canvasZ.current.renderAll()
            console.log(oImg);

        });
    }


    return (
        <div className="zoom" style={!props.show ? {display: 'block'} : {display: 'none'}}>
        <div className="d-flex justify-content-center  bg-dark w-50 m-auto ">
            <div className="form-group">
                <label className="text-light">Zoom</label>
                <input className="form-control-sm" step="0.1" value={value} type="range" min="0.7" max="1.2"  onChange={setZoom} />
            </div>
            <button className="form-control-sm btn btn-sm btn-primary" onClick={props.done}>Done</button>
        </div>
            <canvas id="zoom"    className="fabric"  width="1000"  height="800" />



        </div>
    );
};

export default Zoom;
